import { render, staticRenderFns } from "./SaleTypeAmount.vue?vue&type=template&id=6930c246&scoped=true&"
import script from "./SaleTypeAmount.vue?vue&type=script&lang=js&"
export * from "./SaleTypeAmount.vue?vue&type=script&lang=js&"
import style0 from "./SaleTypeAmount.vue?vue&type=style&index=0&id=6930c246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930c246",
  null
  
)

export default component.exports